import { lgQueries } from './getQueries';
const { findByLgId, getByLgId } = lgQueries;
export { findByLgId, getByLgId };
export { queryBySelector } from './queryBySelector';
